import { bswap } from './bswap';
function isBigEndianFactory() {
    const array = new Uint8Array(4);
    const view = new Uint32Array(array.buffer);
    const isBigEndian = !((view[0] = 1) & array[0]);
    return () => isBigEndian;
}
const isBigEndian = isBigEndianFactory();
export function asLittleEndianByteArray(array, bigEndian = isBigEndian()) {
    let databuffer;
    if (bigEndian) {
        // Create a clone as we don't want to alter data
        const clone = array.slice(0);
        // Swap bytes to little-endian
        bswap(clone);
        databuffer = clone;
    }
    else {
        databuffer = array;
    }
    const bytes = databuffer.buffer.slice(databuffer.byteOffset, databuffer.byteOffset + databuffer.byteLength);
    return new Uint8Array(bytes);
}
export function fixEndianness(array, bigEndian = isBigEndian()) {
    if (bigEndian) {
        bswap(array);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXJyYXlzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2xpYi91dGlscy9hcnJheXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLEtBQUssRUFBRSxNQUFNLFNBQVMsQ0FBQTtBQUcvQixTQUFTLGtCQUFrQjtJQUN6QixNQUFNLEtBQUssR0FBRyxJQUFJLFVBQVUsQ0FBQyxDQUFDLENBQUMsQ0FBQTtJQUMvQixNQUFNLElBQUksR0FBRyxJQUFJLFdBQVcsQ0FBQyxLQUFLLENBQUMsTUFBTSxDQUFDLENBQUE7SUFDMUMsTUFBTSxXQUFXLEdBQUcsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxHQUFHLENBQUMsQ0FBQyxHQUFHLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFBO0lBRS9DLE9BQU8sR0FBRyxFQUFFLENBQUMsV0FBVyxDQUFBO0FBQzFCLENBQUM7QUFFRCxNQUFNLFdBQVcsR0FBRyxrQkFBa0IsRUFBRSxDQUFBO0FBRXhDLE1BQU0sVUFBVSx1QkFBdUIsQ0FDckMsS0FBaUIsRUFDakIsU0FBUyxHQUFHLFdBQVcsRUFBRTtJQUV6QixJQUFJLFVBQVUsQ0FBQTtJQUNkLElBQUksU0FBUyxFQUFFLENBQUM7UUFDZCxnREFBZ0Q7UUFDaEQsTUFBTSxLQUFLLEdBQUcsS0FBSyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQTtRQUM1Qiw4QkFBOEI7UUFDOUIsS0FBSyxDQUFDLEtBQUssQ0FBQyxDQUFBO1FBQ1osVUFBVSxHQUFHLEtBQUssQ0FBQTtJQUNwQixDQUFDO1NBQU0sQ0FBQztRQUNOLFVBQVUsR0FBRyxLQUFLLENBQUE7SUFDcEIsQ0FBQztJQUNELE1BQU0sS0FBSyxHQUFHLFVBQVUsQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUNuQyxVQUFVLENBQUMsVUFBVSxFQUNyQixVQUFVLENBQUMsVUFBVSxHQUFHLFVBQVUsQ0FBQyxVQUFVLENBQzlDLENBQUE7SUFDRCxPQUFPLElBQUksVUFBVSxDQUFDLEtBQUssQ0FBQyxDQUFBO0FBQzlCLENBQUM7QUFFRCxNQUFNLFVBQVUsYUFBYSxDQUFDLEtBQWlCLEVBQUUsU0FBUyxHQUFHLFdBQVcsRUFBRTtJQUN4RSxJQUFJLFNBQVMsRUFBRSxDQUFDO1FBQ2QsS0FBSyxDQUFDLEtBQUssQ0FBQyxDQUFBO0lBQ2QsQ0FBQztBQUNILENBQUMifQ==